import { EmptyState } from '@components/empty-state';
import { IconPublish } from '@components/icons/publish';

export const FormLoadError = () => {
  return (
    <EmptyState
      header="Link inactive"
      content="This form has already been completed or never existed."
      icon={<IconPublish size={80} />}
    />
  );
};
